/**
 * Created by zoupeiyang on 2018/1/20.
 */
import {isIE} from './jssFunction'
import {writeAppLog} from './deviceOperate'





export function setCallBackFun(fun) {
    if (isIE()&&global.LOCAL_DATA.cashPayInfo.callBackInitFlag==0) {
        writeAppLog(4,"回调事件绑定成功..");
        global.LOCAL_DATA.cashPayInfo.callBackInitFlag=1;
        document.getElementById("DeviceMgr").attachEvent("DeviceEvent", function (DeviceID, UserEvtID, RetCode, RetMsg) {
            writeAppLog(4,"回调事件日志：DeviceID："+DeviceID+" UserEvtID:"+UserEvtID+" RetCode:"+RetCode+" RetMsg:"+RetMsg);

            fun(DeviceID, UserEvtID, RetCode, RetMsg);
        });
    }
    else if(global.LOCAL_DATA.cashPayInfo.callBackInitFlag==0) {
        writeAppLog(4,"回调事件绑定成功..");
        global.LOCAL_DATA.cashPayInfo.callBackInitFlag=1;
        window.onDeviceEvent = function (DeviceID, UserEvtID, RetCode, RetMsg) {
            writeAppLog(4,"回调事件日志：DeviceID："+DeviceID+" UserEvtID:"+UserEvtID+" RetCode:"+RetCode+" RetMsg:"+RetMsg);
            fun(DeviceID, UserEvtID, RetCode, RetMsg);
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/devcieCallback.js